import { Popup } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { memo, useMemo } from 'react';
import { useGetQBooksRequestsDuplicates } from 'shared/data/webApp/v2';

import { getRequest } from '../../../../selectors/pageSelectors';
import {
    getQBooksAccountLineItemsSummary,
    getQBooksLineItemsSummary,
    mergeSummaries,
} from '../../../../selectors/qbooks';
import { useDuplicatesPopup } from '../../CheckDuplicatesPopup.hooks';
import { PopupContent } from '../PopupContent/PopupContent';
import { QBooksPopupProps } from './QBooksPopup.types';

export const QBooksPopup = memo<QBooksPopupProps>((props) => {
    const { onCancel, onSubmit } = props;

    const request = useSelector<domain.QBooksBillRequest>(getRequest);
    const qBooksLineItemsSummary = useSelector((state) => getQBooksLineItemsSummary(state, request));
    const qBooksAccountLineItemsSummary = useSelector((state) => getQBooksAccountLineItemsSummary(state, request));

    const summary = useMemo(
        () => mergeSummaries(qBooksLineItemsSummary, qBooksAccountLineItemsSummary),
        [qBooksAccountLineItemsSummary, qBooksLineItemsSummary]
    );

    const getDuplicates = useGetQBooksRequestsDuplicates({
        path: {
            companyId: request.companyId,
        },
        query: {
            amount: summary.totalAmount,
            currency: request.currency,
            date: request.details.date,
            vendorId: request.details.vendor?.id,
            integrationCode: request.integrationCode,
            invoiceNumber: request.details.number,
        },
    });

    const { isOpen, toggleIsOpen, currentDuplicates, handleSubmit, handleCancel } = useDuplicatesPopup({
        onCancel,
        onSubmit,
        ...getDuplicates,
    });

    return (
        <Popup open={isOpen} onToggle={toggleIsOpen} onClose={handleCancel}>
            <PopupContent duplicates={currentDuplicates} onCancel={handleCancel} onSubmit={handleSubmit} />
        </Popup>
    );
});

QBooksPopup.displayName = 'QBooksPopup';
